import React from "react";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import {ReactComponent as English} from "../../assets/svg/united-kingdom.svg";
import {ReactComponent as Iran} from "../../assets/svg/iran.svg";

const ChangeLang = ({label = true,color = 'dark'})=>{
    const { t } = useTranslation('common');

    const changeLanguage = (lng) => {
        i18next.changeLanguage(lng);
        if(typeof window !== "undefined") window.localStorage.setItem('lang',lng)
    }
    return(
        <div className="lang-change" onClick={(e) => {
            const value = t('lang') === 'fa' ? 'en' : 'fa';
            changeLanguage(value)
        }}>
        <div className='change-lang-wrap'>
            <button id='change-lang'>
                {t('lang') === 'fa' ? "English" :"فارسی"}
            </button>
        </div>
            {t('lang') === 'fa' ? <English/> : <Iran/>}
        </div>
    )
}

export default ChangeLang;